import React from 'react'
import { Helmet } from 'react-helmet-async'

import { SITE_DESCRIPTION, SITE_KEYWORDS, SITE_TITLE, SITE_URL } from '../lib/constants'

type Props = {
  path: string
  title?: string
  description?: string | null
  keywords?: string[]
  image?: string
}

export const Head = ({ path, title, description, keywords, image }: Props) => {
  const defaultTitle = SITE_TITLE
  const defaultDescription = SITE_DESCRIPTION
  const defaultKeywords = SITE_KEYWORDS
  const siteUrl = SITE_URL
  const url = `${siteUrl}${path}`
  const defaultImage = `${siteUrl}/logo.png`

  const metaTitle = title || defaultTitle
  const metaDescription = description || defaultDescription
  const ogpImage = image || defaultImage

  return (
    <Helmet>
      <title>{title || defaultTitle}</title>
      <meta key="keywords" name="keywords" content={keywords?.join(',') || defaultKeywords} />
      <meta key="description" name="description" content={metaDescription}></meta>

      <meta key="og:title" property="og:title" content={metaTitle} />
      <meta key="og:description" property="og:description" content={metaDescription} />
      <meta key="og:type" property="og:type" content="article" />
      <meta key="og:url" property="og:url" content={url} />
      <meta key="og:image" property="og:image" content={ogpImage} />
      <meta key="os:site_name" property="og:site_name" content={metaTitle} />

      <meta key="twitter:card" name="twitter:card" content="summary" />
      <meta key="twitter:url" name="twitter:url" content={url} />
      <meta key="twitter:title" name="twitter:title" content={metaTitle} />
      <meta key="twitter:description" name="twitter:description" content={metaDescription} />
      <meta key="twitter:image" name="twitter:image" content={ogpImage} />

      <link rel="canonical" href={url} />
      <link rel="shortcut icon" type="image/png" href="/favicon.png" />
      <link rel="apple-touch-icon" sizes="330x330" href="/logo330.png" />

      <meta key="application-name" name="application-name" content={defaultTitle} />
      <meta key="apple-mobile-web-app-capable" name="apple-mobile-web-app-capable" content="yes" />
      <meta
        key="apple-mobile-web-app-status-bar-style"
        name="apple-mobile-web-app-status-bar-style"
        content="default"
      />
      <meta
        key="apple-mobile-web-app-title"
        name="apple-mobile-web-app-title"
        content={defaultTitle}
      />
      <meta key="format-detection" name="format-detection" content="telephone=no" />
      <meta key="mobile-web-app-capable" name="mobile-web-app-capable" content="yes" />
      <meta key="theme-color" name="theme-color" content="#000000" />
      <link key="manifest" rel="manifest" href="/manifest.json" />
    </Helmet>
  )
}
